document.addEventListener('DOMContentLoaded', function() {
  const categoryButtons = document.querySelectorAll('.es-category-btn');
  const filterableElements = document.querySelectorAll('[data-category]');
  
  function getURLParameter(name) {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get(name);
  }

  function updateURLParameter(name, value) {
    const url = new URL(window.location);
    if (value) {
      url.searchParams.set(name, value);
    } else {
      url.searchParams.delete(name);
    }
    window.history.pushState({}, '', url);
  }

  function filterContent(categoryId) {
    filterableElements.forEach(element => {
      if (element.classList.contains('es-category-btn')) {
        return;
      }
      
      const elementCategory = element.getAttribute('data-category');
      const shouldShow = categoryId === 'all' || elementCategory === categoryId;
      
      if (shouldShow) {
        element.style.display = 'flex';
        element.style.opacity = '1';
      } else {
        element.style.display = 'none';
        element.style.opacity = '0';
      }
    });
  }

  function setActiveCategory(activeButton) {
    categoryButtons.forEach(btn => btn.classList.remove('es-category-btn--active'));
    if (activeButton) {
      activeButton.classList.add('es-category-btn--active');
    }
  }

  function selectCategoryByHandle(categoryHandle) {
    if (!categoryHandle) return false;
    
    const targetButton = Array.from(categoryButtons).find(btn => {
      const btnCategory = btn.getAttribute('data-category');
      return btnCategory === categoryHandle;
    });
    
    if (targetButton) {
      const categoryId = targetButton.getAttribute('data-category');
      setActiveCategory(targetButton);
      filterContent(categoryId);
      return true;
    }
    
    return false;
  }

  function initVideoControls() {
    const videoContainers = document.querySelectorAll('.es-video-container');
    
    videoContainers.forEach(container => {
      const playButton = container.querySelector('.es-play-button');
      const videoCover = container.querySelector('.es-video-cover');
      const iframe = container.querySelector('.es-video-iframe');
      const nativeVideo = container.querySelector('.es-video-native');
      
      if (!playButton || !videoCover) return;
      
      let isPlaying = false;
      let player = null;
      
      function togglePlay() {
        if (isPlaying) {
          pauseVideo();
        } else {
          playVideo();
        }
      }
      
      function playVideo() {
        if (iframe) {
          const videoType = iframe.getAttribute('data-video-type');
          
          if (videoType === 'youtube') {
            if (!player) {
              iframe.src = iframe.src.replace('autoplay=0', 'autoplay=1');
            } else {
              player.playVideo();
            }
          } else if (videoType === 'vimeo') {
            iframe.src = iframe.src.replace('autoplay=0', 'autoplay=1');
          }
        } else if (nativeVideo) {
          nativeVideo.play();
        }
        
        isPlaying = true;
        playButton.classList.add('playing');
        
        videoCover.style.opacity = '0';
        setTimeout(() => {
          videoCover.style.display = 'none';
        }, 300);
      }
      
      function pauseVideo() {
        if (iframe) {
          const videoType = iframe.getAttribute('data-video-type');
          
          if (videoType === 'youtube') {
            if (player) {
              player.pauseVideo();
            }
          } else if (videoType === 'vimeo') {
            iframe.src = iframe.src.replace('autoplay=1', 'autoplay=0');
          }
        } else if (nativeVideo) {
          nativeVideo.pause();
        }
        
        isPlaying = false;
        playButton.classList.remove('playing');
      }
      
      playButton.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        togglePlay();
      });
      
      if (iframe) {
        const videoType = iframe.getAttribute('data-video-type');
        
        if (videoType === 'youtube') {
          if (typeof YT !== 'undefined' && YT.Player) {
            player = new YT.Player(iframe, {
              events: {
                'onStateChange': function(event) {
                  if (event.data === YT.PlayerState.PLAYING) {
                    isPlaying = true;
                    playButton.classList.add('playing');
                  } else if (event.data === YT.PlayerState.PAUSED || event.data === YT.PlayerState.ENDED) {
                    isPlaying = false;
                    playButton.classList.remove('playing');
                  }
                }
              }
            });
          }
        }
      } else if (nativeVideo) {
        nativeVideo.addEventListener('play', function() {
          isPlaying = true;
          playButton.classList.add('playing');
        });
        
        nativeVideo.addEventListener('pause', function() {
          isPlaying = false;
          playButton.classList.remove('playing');
        });
        
        nativeVideo.addEventListener('ended', function() {
          isPlaying = false;
          playButton.classList.remove('playing');
        });
      }
    });
  }

  categoryButtons.forEach(button => {
    button.addEventListener('click', function() {
      const categoryId = this.getAttribute('data-category');
      setActiveCategory(this);
      filterContent(categoryId);
      updateURLParameter('category', categoryId);
    });
  });

  // Check URL parameter on load
  const urlCategory = getURLParameter('category');
  if (urlCategory) {
    const categorySelected = selectCategoryByHandle(urlCategory);
    if (!categorySelected) {
      // If category from URL doesn't exist, use first button
      const firstButton = document.querySelector('.es-category-btn--active') || categoryButtons[0];
      if (firstButton) {
        const categoryId = firstButton.getAttribute('data-category');
        setActiveCategory(firstButton);
        filterContent(categoryId);
        updateURLParameter('category', categoryId);
      }
    }
  } else {
    // No URL parameter, use first active button or first button
    const firstButton = document.querySelector('.es-category-btn--active') || categoryButtons[0];
    if (firstButton) {
      const categoryId = firstButton.getAttribute('data-category');
      setActiveCategory(firstButton);
      filterContent(categoryId);
    }
  }
  
  initVideoControls();
});
